import { Card, CardHeader, Stack } from '@mui/material'
import { memo } from 'react'
import { Trans } from 'react-i18next'

import { formatTicks } from '../../util/string.helpers'
import NextPaymentTimer from '../common/NextPaymentTimer'
import { Label } from '../shared/label'
import Text from '../shared/text/Text'

const HowToEarn = ({ t, symbol, maxPosts }) => {
  return (
    <Card sx={{ p: 3 }}>
      <CardHeader
        title={t('earn-via.how-to-earn', { symbol })}
        subheader={
          <Trans i18nKey='earn-via.how-to-earn-desc' values={{ symbol }} />
        }
        sx={{ p: 0 }}
      />
      <Stack spacing={2} alignItems='flex-start' mt={2}>
        <Text
          label={
            <>
              <strong>{t('earn-via.next-posts-count')}:</strong>{' '}
              <NextPaymentTimer />
            </>
          }
        />
        <Label color='primary'>
          {t('earn-via.max-posts-rewarded')}: {formatTicks(maxPosts)}
        </Label>
      </Stack>
    </Card>
  )
}

export default memo(HowToEarn)
